






















import Vue from 'vue';
import JerseyButtonRed from '@/components/elements/JerseyButtonRed.vue';
import JerseyField from '@/components/elements/JerseyField.vue';
import JerseyProgress from '@/components/elements/JerseyProgress.vue';
import JerseyQuestion from '@/components/elements/JerseyQuestion.vue';
import QuestionLayout from '@/views/QuestionLayout.vue';

export default Vue.extend({
  name: 'Name',
  components: { JerseyButtonRed, JerseyField, JerseyProgress, QuestionLayout },
  methods: {},
  computed: {
    isDisabled() {
      return (
        (this as any).$store.state.firstName.trim().length === 0 ||
        (this as any).$store.state.lastName.trim().length === 0
      );
    },
  },
});
